(function() {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let animationFrameId = null;

    function easeInOutCubic(progress) {
        if (progress < 0.5) {
            return 4 * progress * progress * progress;
        }

        return 1 - Math.pow(-2 * progress + 2, 3) / 2;
    }

    function getCollectionHandle() {
        const pathMatch = window.location.pathname.match(/\/collections\/([^/?#]+)/);
        if (!pathMatch) return null;

        const pathHandle = pathMatch[1];
        const hashHandle = decodeURIComponent(window.location.hash.replace(/^#/, ''));

        return hashHandle || pathHandle;
    }

    function getHeaderOffset() {
        const headerOffset = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-group-height'));
        return Number.isFinite(headerOffset) ? headerOffset + 24 : 24;
    }

    function getCollectionSection(handle) {
        return document.querySelector(`[data-collection="${handle}"]`) || document.getElementById(handle);
    }

    function getTargetTop(section) {
        const top = section.getBoundingClientRect().top + window.scrollY - getHeaderOffset();
        return Math.max(top, 0);
    }

    function animateScrollTo(targetTop, duration, minimumDistance) {
        if (animationFrameId) {
            cancelAnimationFrame(animationFrameId);
            animationFrameId = null;
        }

        if (prefersReducedMotion.matches) {
            window.scrollTo({ top: targetTop });
            return;
        }

        const startTop = window.scrollY;
        const distance = targetTop - startTop;

        if (Math.abs(distance) < minimumDistance) return;

        const startTime = performance.now();

        const step = (currentTime) => {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1);
            const easedProgress = easeInOutCubic(progress);

            window.scrollTo({
                top: startTop + distance * easedProgress
            });

            if (progress < 1) {
                animationFrameId = requestAnimationFrame(step);
            } else {
                animationFrameId = null;
            }
        };

        animationFrameId = requestAnimationFrame(step);
    }

    function scrollCollectionIntoView(options) {
        const handle = getCollectionHandle();
        if (!handle) return;

        const section = getCollectionSection(handle);
        if (!section) return;

        animateScrollTo(getTargetTop(section), options.duration, options.minimumDistance);
    }

    function queueSmartScroll() {
        requestAnimationFrame(() => {
            scrollCollectionIntoView({ duration: 850, minimumDistance: 4 });
        });
    }

    function correctSmartScroll() {
        scrollCollectionIntoView({ duration: 320, minimumDistance: 8 });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', queueSmartScroll);
    } else {
        queueSmartScroll();
    }

    window.addEventListener('load', correctSmartScroll, { once: true });
})();
